import React from "react";
import {Button} from "primereact/button";
import {FileUpload} from "primereact/fileupload";

export default function ProductBriefActions({
    translate,
    valid,
    onSave,
    onClear,
    onLoadExample,
    onCopyPrompt,
    onCopyStrapiPrompt,
    onDownload,
    onExportJson,
    onImportJson,
    onOpenAi,
    savedLabel,
    storageAvailable,
    exporting,
    aiAvailable,
}) {
    return (
        <div className="pbb-actions">
            <div className="pbb-save-state">
                <strong>{storageAvailable ? translate("pbb-draft-local") : translate("pbb-storage-unavailable")}</strong>
                {savedLabel && <span>{translate("pbb-last-save").replace("{{TIME}}", savedLabel)}</span>}
                {!aiAvailable && <span className="pbb-ai-disabled-message">{translate("pbb-ai-no-workspace")}</span>}
            </div>
            <div className="pbb-actions-buttons">
                <Button type="button" icon="pi pi-save" label={translate("pbb-save-draft")} outlined onClick={onSave}/>
                <Button type="button" icon="pi pi-trash" label={translate("pbb-clear-draft")} outlined severity="danger" onClick={onClear}/>
                <Button type="button" icon="pi pi-sparkles" label={translate("pbb-load-meeting-example")} outlined onClick={onLoadExample}/>
                <Button type="button" icon="pi pi-sparkles" label={translate("pbb-ai-open")} outlined disabled={!aiAvailable} onClick={onOpenAi}/>
                <Button type="button" icon="pi pi-file-export" label={translate("pbb-export-json")} outlined onClick={onExportJson}/>
                <FileUpload
                    mode="basic"
                    name="product-brief-json"
                    accept="application/json,.json"
                    maxFileSize={1048576}
                    customUpload
                    auto
                    chooseLabel={translate("pbb-import-json")}
                    className="pbb-json-upload"
                    uploadHandler={onImportJson}
                />
                <Button type="button" icon="pi pi-copy" label={translate("pbb-copy-prompt")} disabled={!valid} onClick={onCopyPrompt}/>
                <Button type="button" icon="pi pi-server" label={translate("pbb-copy-strapi-prompt")} disabled={!valid} onClick={onCopyStrapiPrompt}/>
                <Button type="button" icon="pi pi-file-word" label={translate("pbb-download-word")} disabled={!valid || exporting} loading={exporting} onClick={onDownload}/>
            </div>
        </div>
    );
}
